// Parse seal numbers: "MP6001-MP6100", "MP6001,MP6003", or a mix.
export function parseSeals(raw) {
  const seals = [];
  for (const part of String(raw || "").split(/[,\n]/).map(s => s.trim()).filter(Boolean)) {
    const dash = part.indexOf("-");
    if (dash > 0) {
      const a = part.slice(0, dash).trim();
      const b = part.slice(dash + 1).trim();
      const ma = /^([A-Za-z]*)(\d+)$/.exec(a);
      const mb = /^([A-Za-z]*)(\d+)$/.exec(b);
      if (ma && mb && ma[1] === mb[1]) {
        const prefix = ma[1], start = parseInt(ma[2], 10), end = parseInt(mb[2], 10);
        const width = ma[2].length;
        if (end >= start && end - start <= 20000) {
          for (let n = start; n <= end; n++) seals.push(prefix + String(n).padStart(width, "0"));
          continue;
        }
      }
    }
    seals.push(part);
  }
  return seals;
}
